export default __webpack_public_path__ + "static/bg-plain-7c5d0a0b5cb8a749dcd1243f1018809d.png";